module.exports = __webpack_public_path__ + "static/media/Illus-Dressing_3@3x.e6b372e1.png";